import { render, staticRenderFns } from "./FaultSummary.vue?vue&type=template&id=2c8e99aa&scoped=true&"
import script from "./FaultSummary.vue?vue&type=script&lang=js&"
export * from "./FaultSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e99aa",
  null
  
)

export default component.exports